import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=aab11a48"
var script = {}
import style0 from "./MobileMenu.vue?vue&type=style&index=0&id=aab11a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports